module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/battle-payments-clan-landing-elite-big.0bbc1aef.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/battle-payments-clan-landing-elite-big.png
// module id = 3707
// module chunks = 11